import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";

/**
 * Minimal auth hook. Returns { user, session, loading }.
 * user is null when not logged in or when Supabase is not configured.
 *
 * Usage in DPL Jade.jsx:
 *   const { user } = useAuth();
 *   const saveStatus = useSave(st, projectId, user?.id);
 */
export function useAuth() {
  const [user,    setUser]    = useState(null);
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!supabase) { setLoading(false); return; }

    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUser(session?.user ?? null);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  return { user, session, loading };
}
